<template>
  <Dropdown
    v-model="value"
    :class="{
      '!rounded-[6px]': !props.isNav,
      '!rounded-r-none': props.isNav,
      'w-[90px] min-w-[90px] md:w-[140px]' : !props.noStyle,
    }" 
    option-label="name"
    append-to="self"
    :options="props.options"
    :pt-options="{ mergeProps: true }"
    :loading="loading"
    :pt="{
      root: {
        class: {
          '!bg-[--color-brand-forrest-green-05] border-0 !shadow-none focus:z-0 z-10 border-r border-r-[--v3-input-field-inputborder] group': !props.noStyle
        },
      },
      wrapper: {
        class: {
          'frs-hide-scroll hidden md:block !max-h-[80vh]': !props.noStyle
        },
      },
      input: {
        class: {
          'pr-0 group-hover:text-[--v3-theme-highlighttextcolor]': !props.noStyle
        },
      },
      trigger: {
        class: {
          'group-hover:text-[--v3-theme-highlighttextcolor]': !props.noStyle
        },
      }
    }"
    @click="handleDropdownClick"
  />
</template>

<script setup lang="ts">
import Dropdown from 'primevue/dropdown';
import { defineModel, withDefaults } from 'vue';

import { useMobile }  from '@/common/composables/application';

export interface Marketplace {
  name: string;
  code: string;
}

const value = defineModel<Marketplace>();

const props = withDefaults(
  defineProps<{
    options: Marketplace[];
    isNav?: boolean; // Mark isNav as optional
    loading?: boolean;
    noStyle?: boolean;
  }>(),
  {
    isNav: true, // Default value for isNav
    loading: false,
    noStyle: false,
  },
);

const emit = defineEmits<{
  onMarketplaceSelect: [];
}>();

const { isMobile } = useMobile();

const handleDropdownClick = () => {
  if (isMobile.value) {
    emit('onMarketplaceSelect');
  }
};
</script>
